export const NullValue = 'NULL';
